import { render, staticRenderFns } from "./redPack.vue?vue&type=template&id=b5a632c6&"
import script from "./redPack.vue?vue&type=script&lang=js&"
export * from "./redPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports